"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const MeasureIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.79289 15.935C1.40237 16.3256 1.40237 16.9587 1.79289 17.3492L6.74264 22.299C7.13316 22.6895 7.76633 22.6895 8.15685 22.299L22.299 8.15685C22.6895 7.76633 22.6895 7.13316 22.299 6.74264L17.3492 1.79289C16.9587 1.40237 16.3256 1.40237 15.935 1.79289L1.79289 15.935ZM20.1777 7.44975L16.6421 3.91421L15.2279 5.32843L17.5513 7.65178L16.1371 9.06599L13.8137 6.74264L12.3995 8.15685L14.7228 10.4802L13.3086 11.8944L10.9853 9.57107L9.57107 10.9853L11.8944 13.3086L10.4802 14.7228L8.15685 12.3995L6.74264 13.8137L9.06599 16.1371L7.65178 17.5513L5.32843 15.2279L3.91421 16.6421L7.44975 20.1777L20.1777 7.44975Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.MeasureIcon = MeasureIcon;
//# sourceMappingURL=measure_icon.js.map